/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload': {
    width: 12,
    height: 10,
    viewBox: '0 0 12 10',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M5.757 6.5v-6M7.691 2.644L5.75.718 3.809 2.644M.75 5.957v2.826h10V5.957"/></g>'
  }
})
